export default __webpack_public_path__ + "logo_dark.png";